import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type UnreadMessagesCount as SchemaUnreadMessagesCount } from '../schemas/UnreadMessagesCount';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Messages
 */
export const GetUnreadMessagesCountContentType = '' as const;
export type GetUnreadMessagesCountRequest = void;
export type GetUnreadMessagesCountResponses = LinkCommonErrorResponses & {
    /**
     * @description Number of unread messages
     */
    '200': {
        'application/json': SchemaUnreadMessagesCount;
    };
};
export type GetUnreadMessagesCountResponseSuccess = GetUnreadMessagesCountResponses['200']['application/json'];
export type GetUnreadMessagesCountSearchParams = undefined;
export type GetUnreadMessagesCountPathParameters = undefined;
export const GetUnreadMessagesCountUrl = '/messages/unread_count' as const;
export const GetUnreadMessagesCountMethod = 'GET' as const;
export const getGetUnreadMessagesCountUrl = (_params?: GetUnreadMessagesCountPathParameters) =>
    GetUnreadMessagesCountUrl;
